<template>
  <div class="pdf2pog-page">
    <iframe
      class="pdf2pog-frame"
      src="https://pdf2pogtabular-csgmcjbedhb0dmcu.uksouth-01.azurewebsites.net/"
      frameborder="0"
      allowfullscreen
    />
  </div>
</template>

<script>
export default {
  name: 'PDF2ExcelTabular'
}
</script>

<style scoped>
.pdf2pog-page {
  height: calc(100vh - 64px);
  overflow: hidden;
}

.pdf2pog-frame {
  border: 0;
  display: block;
  height: 100%;
  width: 100%;
}

@media (max-width: 900px) {
  .pdf2pog-page {
    height: calc(100vh - 56px);
  }
}
</style>
